module.exports = __webpack_public_path__ + "static/media/zombies3.c3a045bc.jpg";